import React, { useEffect } from "react";
import Highcharts from "highcharts";
// Import the highcharts treemap module (side-effect import)
import "highcharts/modules/treemap";

const TreemapChart = ({ data }) => {
  useEffect(() => {
    // Create a new Highcharts chart instance
    const chart = Highcharts.chart("treemap-container", {
      chart: {
        type: "treemap",
        height: "40%",
      },
      title: {
        text: "Stock Holding Change",
      },

      series: [
        {
          type: "treemap",
          layoutAlgorithm: "squarified",
          data: data.map((item) => ({
            name: item.stockName,
            value: Math.abs(item.oneMonthChangeInPtHoldings),
            color:
              item.oneMonthChangeInPtHoldings > 0
                ? "rgba(0, 200, 0, 0.5)"
                : item.oneMonthChangeInPtHoldings < 0
                ? "rgba(200, 0, 0, 0.5)"
                : "rgba(200, 200, 200, 0.5)",
          })),
        },
      ],
      tooltip: {
        pointFormat: `<b>{point.name}</b>: {point.value}% change`,
      },
    });

    // Cleanup the chart on component unmount or data change
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [data]);

  return (
    <div id="treemap-container" style={{ width: "100%", height: "600px" }} />
  );
};

export default TreemapChart;
